import type { Brand } from '@apiTypes';
import { NUMBER_LETTER } from '../components/types';

const getFirstLetters = (brands: Brand[]) => {
    const firstLetters = brands.map(item => item.name[0].toLocaleLowerCase());
    const uniqLetters = Array.from(new Set(firstLetters));
    const numberIsExist = uniqLetters.some(item => !Number.isNaN(Number(item)));
    if (numberIsExist) {
        return [...uniqLetters, NUMBER_LETTER];
    }
    return uniqLetters;
};

export default getFirstLetters;
